import React from 'react';
const tomos = [{
  emoji: '📘',
  title: 'Tomo 1 — Arquitectura de Poder',
  desc: 'Estructura, nodos, delegación y autonomía operativa. El sistema para dejar de ser el cuello de botella de tu propia empresa.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — El Imán de Talento',
  desc: 'Atracción, selección, onboarding y retención. Cómo construir el equipo que tu empresa necesita para funcionar sin vos.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — Estrategia de Combate',
  desc: 'Diagnóstico, posicionamiento, Rocks y plan de 90 días. Dirección clara para los próximos 3 meses.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — La Fábrica de Resultados',
  desc: 'Scrum, Kanban, gestión de proyectos y eliminación de la reunionitis. El sistema de ejecución que hace que las cosas pasen.'
}, {
  emoji: '📓',
  title: 'Tomo 5 — Ingeniería de Eficiencia',
  desc: 'Lean, TOC, Six Sigma y optimización operativa. Cómo producir más con los mismos recursos.'
}, {
  emoji: '📔',
  title: 'Tomo 6 — Liderazgo de Hierro',
  desc: 'Crisis, negociación, conflictos y psicología del líder. Para liderar con claridad cuando todo presiona.'
}];
const checklist = ['Framework de implementación inmediata', 'Matrices y herramientas listas para usar', 'Casos prácticos para PyMEs argentinas', 'Worksheets completables', 'Checklists de verificación', 'Ejemplos reales de empresa de servicios y empresa comercial', '100% adaptado al contexto Argentina 2026'];
const bonos = [{
  num: '01',
  title: 'Kit Legal PyME 2026',
  desc: 'Los 7 documentos mínimos para operar con más orden, menos ambigüedad y más respaldo. Contratos, acuerdos de confidencialidad, órdenes de trabajo y registro de incidentes listos para adaptar.',
  value: '$15.000'
}, {
  num: '02',
  title: 'IA en tu Oficina',
  desc: 'Cómo usar inteligencia artificial para ahorrar tiempo, organizar procesos y acelerar la gestión sin volverte técnico. 60+ prompts listos para gestión, ventas, procesos y estrategia.',
  value: '$12.000'
}, {
  num: '03',
  title: 'Finanzas de Guerra',
  desc: 'El sistema simple para defender caja, cuidar margen y tomar decisiones financieras con cabeza fría en tiempos volátiles. Tablero semanal, protocolo de cobranza y plan de supervivencia de 15 días.',
  value: '$15.000'
}, {
  num: '04',
  title: 'Venta por WhatsApp',
  desc: 'Scripts, estructura y seguimiento para cerrar más ventas sin perseguir clientes ni improvisar mensajes. Pipeline completo con etiquetas, secuencias de seguimiento y biblioteca de objeciones.',
  value: '$12.000'
}, {
  num: '05',
  title: 'Cultura Híbrida y Equipos que Responden',
  desc: 'Cómo ordenar equipos presenciales, híbridos o remotos para que trabajen con más claridad, más autonomía y menos caos. Los 5 acuerdos internos que todo equipo necesita.',
  value: '$12.000'
}, {
  num: '06',
  title: 'Auditoría 360 del Negocio',
  desc: 'La revisión completa para detectar fugas, desorden y puntos ciegos antes de que se conviertan en problemas caros. 8 ejes de diagnóstico con sistema de semáforo y plan de acción de 30 días.',
  value: '$15.000'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-[#1F1A17] border-y border-gray-800" data-id="element-144">
      <div className="max-w-6xl mx-auto px-4" data-id="element-145">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-146">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 text-emerald-500 font-bold text-sm mb-6" data-id="element-147">
            🏆 MEGA KIT: MAESTRÍA OPERATIVA 2026
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-148">
            6 Tomos + 6 Bonos
          </h2>
          <p className="text-lg md:text-xl text-gray-400" data-id="element-149">
            Sistema Completo para PyMEs Argentinas
          </p>
          <p className="text-base text-gray-500 mt-2" data-id="element-150">
            360+ páginas — Todo listo para implementar.
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-151">
          {tomos.map((t, i) => <div key={i} className="bg-[#0a0f1a] border border-gray-800 rounded-2xl p-6 md:p-8 hover:border-emerald-500/40 transition-all group" data-id="element-152">
              <div className="text-4xl md:text-5xl mb-5 group-hover:scale-110 transition-transform origin-left" data-id="element-153">
                {t.emoji}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-154">
                {t.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-155">
                {t.desc}
              </p>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-gray-800/40 border border-gray-700 rounded-2xl md:rounded-3xl p-6 md:p-10 mb-20 md:mb-28" data-id="element-156">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 text-center" data-id="element-157">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-158">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-159">
                <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-160">✅</span>
                <span className="text-gray-300 font-medium text-sm md:text-base" data-id="element-161">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-163">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-lg text-emerald-500 font-semibold uppercase tracking-wider" data-id="element-164">
            Siempre incluidos
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-165">
          {bonos.map((b, i) => <div key={i} className="bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col" data-id="element-166">
              <div className="absolute top-0 right-0 w-28 h-28 bg-emerald-500/5 rounded-bl-full -mr-8 -mt-8" data-id="element-167" />
              <div className="text-emerald-500 font-mono font-bold text-lg mb-3" data-id="element-168">
                BONO {b.num}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-169">
                {b.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base mb-6 flex-1" data-id="element-170">
                {b.desc}
              </p>
              <div className="pt-5 border-t border-gray-700/50 flex items-center justify-between" data-id="element-171">
                <span className="text-gray-500 line-through font-mono text-sm" data-id="element-172">
                  {b.value}
                </span>
                <span className="bg-emerald-500 text-gray-950 font-bold px-3 py-1 rounded-md text-xs uppercase tracking-wide" data-id="element-173">
                  Gratis
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-emerald-500/10 border border-emerald-500/30 rounded-2xl p-6 md:p-8" data-id="element-174">
          <div className="text-gray-400 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-175">
            Valor total bonos
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-176">
            <span className="line-through text-gray-500 mr-3" data-id="element-177">$81.000</span>
            <span className="text-emerald-500" data-id="element-178">→ GRATIS con tu Mega Kit</span>
          </div>
        </div>
      </div>
    </section>;
}